import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {plainToClass} from "class-transformer";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {SelectItem} from "primeng/api";
import {CommonTransformationService} from "@app/shared/services/common-transformation.service";
import {PaymentType} from "@app/shared/enums/payment-type.enum";
import {OrgPaymentConfig} from "@app/shared/classes/org-payment-config";

@Injectable()
export class PaymentService {

  constructor (private http: HttpClient, private transform: CommonTransformationService) {
  }

  private baseUrl = "/payments";

  getPaymentConfig(): Observable<any> {
    let url = this.baseUrl + `/config`;
    return  this.http.get(url);
  }

  getPaymentTypeAsDropDown(excludePaymentTypes?: PaymentType[]): Observable<SelectItem[]> {
    return this.getPaymentTypes(excludePaymentTypes).pipe(map( res => {
      return this.transform.convertArrayToDropDown(res);
    }));
  }

  getPaymentTypes(excludePaymentTypes?: PaymentType[]): Observable<PaymentType[]> {
    return this.getPaymentConfig().pipe(map(res => {
      let paymentConfig = plainToClass(OrgPaymentConfig, res as OrgPaymentConfig);
      let paymentTypes = this.filterPaymentTypeBasedOnTransaction(paymentConfig.paymentTypes, excludePaymentTypes);
      return paymentTypes;
    }));
  }


  private filterPaymentTypeBasedOnTransaction(paymentTypes: PaymentType[], excludePaymentTypes: PaymentType[]) {
    let filteredPaymentTypes: PaymentType[] = [];
    //Remove any payment types present in the request
    if (excludePaymentTypes && excludePaymentTypes.length > 0) {
      paymentTypes.forEach((type, index) => {
        if (!excludePaymentTypes.includes(type)) {
          filteredPaymentTypes.push(type);
        }
      });
      return filteredPaymentTypes;
    }
    return paymentTypes;
  }

}
